import { SenderResponseEnum } from '@/src/modules/ContactsModule/hooks/useSenderModal';
import {
  IEmailData,
  ISender,
  ISenderData,
} from '@/src/presentation/types/interfaces/ISenderData.interface';
/** cspell:disable */
export const defaultSender: ISenderData = {
  cardZip: '',
  cardCity: '',
  cardAddress: '',
  cardIndustry: '',
  cardCountry: '',
  cardState: '',
  emailFrom: {
    detail: [
      {
        state: 'Verificado',
        key: 'email',
      },
      {
        state: 'Verificado',
        key: 'spf',
      },
      {
        state: 'Verificado',
        key: 'dkim',
      },
      {
        state: 'Verificado',
        key: 'dmarc',
      },
    ],
    email: 'defaultsender@mailingmktg.com',
    id: '67668',
    default: true,
  },
  emailReply: {
    detail: [
      {
        state: 'Verificado',
        key: 'email',
      },
      {
        state: 'Verificado',
        key: 'spf',
      },
      {
        state: 'Verificado',
        key: 'dkim',
      },
      {
        state: 'Verificado',
        key: 'dmarc',
      },
    ],
    email: 'defaultsender@mailingmktg.com',
    id: '67668',
    default: true,
  },
  id: 104365,
  nameFrom: 'sender',
  default: false,
};

export const createSenderMock: ISender = {
  notification: {
    content: true,
    id_notification: SenderResponseEnum.senderCreate,
  },
  sender: defaultSender,
};

export const senderListDataMock: ISenderData[] = [
  defaultSender,
  {
    cardZip: '',
    cardCity: '',
    cardAddress: '',
    cardIndustry: 'emBlue',
    cardCountry: '',
    cardState: '',
    emailFrom: {
      detail: [
        {
          state: 'Verificado',
          key: 'email',
        },
        {
          state: 'Verificado',
          key: 'spf',
        },
        {
          state: 'Verificado',
          key: 'dkim',
        },
        {
          state: 'Verificado',
          key: 'dmarc',
        },
      ],
      email: 'jesus.tovar@embluemail.com',
      id: '67770',
      default: false,
    },
    emailReply: {
      detail: [
        {
          state: 'Verificado',
          key: 'email',
        },
        {
          state: 'Verificado',
          key: 'spf',
        },
        {
          state: 'Verificado',
          key: 'dkim',
        },
        {
          state: 'Verificado',
          key: 'dmarc',
        },
      ],
      email: 'jesus.tovar@embluemail.com',
      id: '67770',
      default: false,
    },
    id: 104365,
    nameFrom: 'sender emBlue',
    default: true,
  },
];

export const emailsDataMock: IEmailData[] = [
  {
    detail: [
      {
        state: 'No verificado',
        key: 'email',
      },
      {
        state: 'Inexistente',
        key: 'spf',
      },
      {
        state: 'Inexistente',
        key: 'dkim',
      },
      {
        state: 'Inexistente',
        key: 'dmarc',
      },
    ],
    email: 'defaultsender@mailingmktg.co',
    id: '67749',
    default: false,
  },
  {
    detail: [
      {
        state: 'Verificado',
        key: 'email',
      },
      {
        state: 'Verificado',
        key: 'spf',
      },
      {
        state: 'Verificado',
        key: 'dkim',
      },
      {
        state: 'Verificado',
        key: 'dmarc',
      },
    ],
    email: 'defaultsender@mailingmktg.com',
    id: '67668',
    default: true,
  },
  {
    detail: [
      {
        state: 'Verificado',
        key: 'email',
      },
      {
        state: 'Verificado',
        key: 'spf',
      },
      {
        state: 'Verificado',
        key: 'dkim',
      },
      {
        state: 'Verificado',
        key: 'dmarc',
      },
    ],
    email: 'jesus.tovar@embluemail.com',
    id: '67770',
    default: false,
  },
  {
    detail: [
      {
        state: 'No verificado',
        key: 'email',
      },
      {
        state: 'Verificado',
        key: 'spf',
      },
      {
        state: 'Verificado',
        key: 'dkim',
      },
      {
        state: 'Verificado',
        key: 'dmarc',
      },
    ],
    email: 'sandra.b@embluemail.com',
    id: '67772',
    default: false,
  },
];
//**cspell:enable */
